/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../geometry.js";
import e from "../../../core/Error.js";
import r from "../../../core/Logger.js";
import { isNone as t } from "../../../core/maybe.js";
import { getExtentForScale as n } from "../../../geometry/support/scaleUtils.js";
import i from "../../../geometry/Extent.js";
var o = r.getLogger("esri.widgets.Search.support.geometryUtils");

function s(r, t) {
  var n, i;
  if (!t) return o.error("missing-parameter: view is missing."), Promise.reject(new e("searchgeometryutils:missing-parameter", "view is missing."));
  if (!r) return o.error("missing-parameter: point is missing."), Promise.reject(new e("searchgeometryutils:missing-parameter", "point is missing."));
  if (r.hasZ || "2d" === t.type) return Promise.resolve(r);
  var s = null == t || null == (n = t.map) ? void 0 : n.ground;
  return s && s.layers.length ? s.queryElevation(r, {
    cache: null == (i = t.basemapTerrain) ? void 0 : i.elevationQueryCache
  }).then(function (e) {
    return e.geometry;
  }) : Promise.resolve(r);
}

function m(e) {
  if (t(e)) return null;

  switch (e.type) {
    case "point":
      return e;

    case "extent":
      return e.center;

    case "polygon":
      return e.centroid;

    case "multipoint":
      return e.getPoint(0);

    case "polyline":
      return e.getPoint(0, 0);
  }

  return null;
}

function a(e, r, n) {
  return t(e) ? null : "extent" === e.type ? e : "multipoint" === e.type || "polygon" === e.type || "polyline" === e.type ? e.extent : "point" === e.type ? l(e, r, n) : void 0;
}

function p(e, r, n) {
  return t(e) || t(r) ? null : l(e.center, r, n);
}

function l(e, r, t) {
  var o = e.hasZ ? e.z : void 0;

  if (r && r.map) {
    return (t ? n(r, t) : r.extent).clone().centerAt(e).set({
      zmax: o,
      zmin: o
    });
  }

  return new i({
    xmin: e.x - .25,
    ymin: e.y - .25,
    xmax: e.x + .25,
    ymax: e.y + .25,
    spatialReference: e.spatialReference,
    zmin: o,
    zmax: o
  });
}

export { a as createExtentFromGeometry, m as getPointFromGeometry, s as getPointWithElevation, p as scaleExtent };